import {prepareOptions} from '../../helpers/common';

require('./style.scss');

class E3Loading {
    _options = {
        classNames: [],
        events: {}
    };
    _element = null;
    _container = null;

    constructor(container, options) {
        this._options = prepareOptions(this._options, options);
        this._container = container;
        this._element = this._createElement();
    }

    _createElement() {
        const element = document.createElement('div');
        const {classNames} = this._options;

        element.classList.add('e3-loading');
        classNames
            .forEach((className) => element.classList.add(className));

        this._container.appendChild(element);

        return element;
    }

    element() {
        return this._element;
    }

    hide() {
        this._element.classList.add('hidden');
    }

    show() {
        this._element.classList.remove('hidden');
    }

    destroy() {
        this._unbindEvents();
        this._container.removeChild(this._element)
    }
}

export default E3Loading;